import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { assetMembershipApi } from 'src/Services/API';
import { MemberForecastSummaryDto } from 'src/Services/API/generated';
import { ApiError } from 'src/types/api-error.types';

const useMemberAnnualForecastPosition = (
  assetId: string | undefined,
  userId: string | undefined,
  year: number = new Date().getFullYear()
) => {
  return useQuery<MemberForecastSummaryDto, AxiosError<ApiError>>({
    queryKey: ['fetch-member-forecast-summary', assetId, userId, year],
    queryFn: async () => {
      if (!assetId || !userId) throw new Error('No assetId/userId provided');

      return (
        await assetMembershipApi.membersControllerGetForecastSummary(assetId, userId, String(year))
      ).data;
    },
    enabled: !!assetId && !!userId,
  });
};

export default useMemberAnnualForecastPosition;
